import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { AnalyticsService } from '@core/services/analytics.service';
import { select, Store } from '@ngrx/store';
// import { ToggleFilter } from '@results/store/results.actions';
import { IHotelsAppState } from '@store/index';
import { selectOrderByQueryParam } from '@store/router/router.selector';
import { Ga4Service } from '@core/services/ga4.service';
import { toggleFilter } from '@results/store/results.actions';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MbFormField, MbFormFieldLabel, MbFormFieldSelect } from '@am/moebius';

@Component({
  selector: 'am-sorting-by',
  standalone: true,
  styleUrls: ['./sorting-by.component.scss'],
  templateUrl: './sorting-by.component.html',
  imports: [MbFormField, MbFormFieldLabel, MbFormFieldSelect, FormsModule, CommonModule],
})
export class SortingByComponent implements OnInit, OnChanges {
  @Input()
  public disabled: boolean;

  public sortingValue: any;

  constructor(
    private store$: Store<IHotelsAppState>,
    private changeDetectorRef: ChangeDetectorRef,
    private analyticsService: AnalyticsService,
    private ga4Service?: Ga4Service,
  ) {}

  public ngOnInit(): void {
    this.store$.pipe(select(selectOrderByQueryParam)).subscribe((orderBy) => {
      this.sortingValue = orderBy.sortBy
        ? `${orderBy.sortBy}-${orderBy.sortCriteria}`
        : 'recommended';
    });
  }
  public ngOnChanges(changes: SimpleChanges) {
    if (changes.disabled) {
      this.changeDetectorRef.detectChanges();
    }
  }

  public applyChange() {
    const ga4Data = {
      type: 'ordenar por',
      label: this.sortingValue,
      action: 'select',
      section: 'ordenamiento',
    };
    this.trackSorting(this.sortingValue);
    const sortArray = this.sortingValue !== 'recommended' ? this.sortingValue.split('-') : [];
    const newSortingData = {
      sortBy: sortArray[0],
      sortCriteria: sortArray[1],
    };
    if (this.ga4Service !== undefined) {
      this.ga4Service.user_interaction(ga4Data, 'PLP');
    }

    this.store$.dispatch(toggleFilter({ payload: newSortingData }));
  }

  private trackSorting(sortType) {
    const map = {
      ASC: 'Lowest',
      DESC: 'Highest',
      price: 'Price',
      rating: 'Score Review',
      recommended: 'Recommended',
      stars: 'Stars',
    };
    const splitValue = sortType.split('-');
    this.analyticsService.trackEvent({
      action: 'Sort',
      label:
        map[splitValue[0]] + '|' + (map[splitValue[1]] ? map[splitValue[1]] : map[splitValue[0]]),
      section: 'Results',
    });
  }
}
